var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-prompt',{staticClass:"operation-report-csv-download-dialog max-w-fit",attrs:{"title":_vm.title,"color":_vm.color,"type":_vm.type,"accept-text":_vm.acceptText,"cancel-text":_vm.cancelText,"active":_vm.active},on:{"accept":_vm.onAccept,"cancel":_vm.onCancel,"close":_vm.onCancel}},[_c('div',[_vm._v("\n    "+_vm._s(_vm.confirmText)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }